import { QuestionBase } from './question-base.model';

export class Link extends QuestionBase<string> {
    controlType = 'link';
    action_name:string;
    aciton_type:string;
    action_config:any;
    changeable:boolean;
    constructor(options: {} = {}) {
        super(options);
        this.action_name = options['action_name'] || '';
        this.aciton_type = options['aciton_type'] || '';
        this.action_config = options['action_config'] || '';
        this.changeable = options['changeable'] || false;
    }
}
